import React from 'react';
import { ChevronRight } from 'lucide-react';

const PageHeader = ({ 
  title, 
  description, 
  breadcrumbs = [], 
  action 
}) => {
  return (
    <div className="mb-6 sm:mb-8">
      {breadcrumbs.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
          {breadcrumbs.map((crumb, idx) => (
            <React.Fragment key={idx}>
              {idx > 0 && <ChevronRight size={14} className="text-gray-400 flex-shrink-0" />}
              <span className={idx === breadcrumbs.length - 1 ? 'text-gray-900 font-semibold' : ''}>
                {crumb}
              </span>
            </React.Fragment>
          ))}
        </div>
      )}
      
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">{title}</h1>
          {description && (
            <p className="mt-1 text-xs sm:text-sm text-gray-600 leading-relaxed">{description}</p>
          )}
        </div>
        {action && <div className="w-full sm:w-auto flex-shrink-0">{action}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
